import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 90AD6D2A-7986-49D0-8DA5-DC92F9F92A15
 * name play
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/play.svg
 * tags
 * - Home Automation 
 */
export const PlayIcon = createSvgIcon(<><path d="M8,5.14V19.14L19,12.14L8,5.14Z" /></>, 'PlayIcon');
export default PlayIcon